function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("title", null, "Warning");
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Final",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grafiska-element",
  transform: "translate(-705.000000, -868.000000)",
  fill: "currentColor",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M732.68738,888.957661 L721.022118,869.143145 C720.12904,867.618952 717.875286,867.618952 716.976191,869.143145 L705.316397,888.957661 C704.418944,890.476411 705.536742,892.387097 707.335533,892.387097 L730.666059,892.387097 C732.457686,892.387097 733.578819,890.481855 732.687381,888.957661 L732.68738,888.957661 Z M717.645161,874.774194 C717.645161,874.02621 718.252016,873.419355 719,873.419355 C719.747984,873.419355 720.354839,874.029032 720.354839,874.774194 L720.354839,882 C720.354839,882.747984 719.747984,883.354839 719.050806,883.354839 C718.353628,883.354839 717.645161,882.750806 717.645161,882 L717.645161,874.774194 Z M719.451613,890.580645 C718.454157,890.580645 717.645161,889.77165 717.645161,888.774194 C717.645161,887.776739 718.453583,886.967742 719.451613,886.967742 C720.449643,886.967742 721.258065,887.776737 721.258065,888.774194 C721.255766,889.7705 720.451366,890.580645 719.451613,890.580645 Z",
  id: "Warning"
})));
const SvgIconWarning = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "25px",
    viewBox: "0 0 28 25",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};
const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconWarning, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-warning.c84f13fb.svg";
export { ForwardRef as ReactComponent };